import * as React from 'react';
import {Container} from '../grid/container';
import './style.scss';
import {Translation} from "../../lang";

const list: any[] = [
    {
        title: Translation.get('application.devOps.title'),
        description: Translation.get('application.devOps.description'),
        icons: [
            '/assets/src/components/applications/aws.svg',
            '/assets/src/components/applications/awsec2.svg',
            '/assets/src/components/applications/awss3.svg'
        ]
    },
    {
        title: Translation.get('application.enterpriseCodeDelivery.title'),
        description: Translation.get('application.enterpriseCodeDelivery.description'),
        icons: [
            '/assets/src/components/applications/docker.svg',
            '/assets/src/components/applications/circleci.svg',
            '/assets/src/components/applications/github.svg'
        ]
    },
    {
        title: Translation.get('application.enterpriseApplicationsBackend.title'),
        description: Translation.get('application.enterpriseApplicationsBackend.description'),
        icons: [
            '/assets/src/components/applications/symfony.svg',
            '/assets/src/components/applications/nodejs.svg',
            '/assets/src/components/applications/CSharp.svg'
        ]
    },
    {
        title: Translation.get('application.databaseDesign.title'),
        description: Translation.get('application.databaseDesign.description'),
        icons: [
            '/assets/src/components/applications/redis.svg',
            '/assets/src/components/applications/mongodb.svg',
            '/assets/src/components/applications/mysql.svg'
        ]
    },
    {
        title: Translation.get('application.fullStack.title'),
        description: Translation.get('application.fullStack.description'),
        icons: [
            '/assets/src/components/applications/react.svg',
            '/assets/src/components/applications/angular.svg',
            '/assets/src/components/applications/electron.svg'
        ]
    },
    {
        title: Translation.get('application.visualHeavy.title'),
        description: Translation.get('application.visualHeavy.description'),
        icons: [
            '/assets/src/components/applications/unity.svg',
            '/assets/src/components/applications/d3.svg',
            '/assets/src/components/applications/webgl.svg'
        ]
    }
];

export class ApplicationsComponent extends React.Component<any, any> {
    render() {
        return <Container className="applicationsComponent">

            <div
                className="col-12 col-sm-10 col-md-10 col-lg-7 col-xl-6 MS text-white text-center content-height">

                <h1 className="fw-bold fst-italic">{Translation.get('application.title')}</h1>
                <p className="fst-italic">{Translation.get('application.description')}</p>
                <br/>
                <br/>
            </div>

            <div className="container">

                {list.map((item: any, index: number) => <div className="pt-5 " key={index}>
                    <div className={`d-block d-lg-flex ${(index % 2) ? 'flex-sm-row-reverse' : ''}`}>
                        <div className={`col-12 col-lg-6 ${(index % 2) ? '' : ''}`}>
                            <h3 className="fw-bold fst-italic text-white">{item.title}</h3>
                            <p>{item.description}</p>
                        </div>
                        <div
                            className={`col-12 col-lg-6 d-block d-sm-block d-md-flex justify-content-center mt-5 mt-lg-0`}>
                            {item.icons.map((imgSrc: string, indexImg: number) => <img
                                key={indexImg}
                                src={imgSrc}
                                alt={imgSrc}
                                style={{minWidth: '85px', height: '85px'}}
                                className="img-responsive col-2 pl-md-4 pr-md-4 col-lg-3 col-xl-2"/>)}
                        </div>
                    </div>
                </div>)}
            </div>

        </Container>;
    }
}
